import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-visitor-generic-container",
  templateUrl: "./visitor-generic-container.component.html",
  styleUrls: ["./visitor-generic-container.component.scss"],
})
export class VisitorGenericContainerComponent implements OnInit {
  componentID: any;
  @Input() componentId;
  @Input() editableMode;
  @Input() editableReference;
  @Input() editableInviter;
  @Input() dynamic;
  @Output() VisitorEntryAdd = new EventEmitter();
  
  constructor() {
  }

  dynamicContinue(data:any){
   this.VisitorEntryAdd.emit(data);
  }

  ngOnInit() {
    if(this.componentId == 1){
      this.componentId;
      this.editableInviter
    }else if(this.componentId == 2){
      this.componentId;
      this.editableReference
    }   
  }
}
